/* @jsx h */
import { defineComponent, h } from "vue";
import { RightSheet, useLocalization } from "@lemmonhq/uikit";
import { LiveStatusPage } from "../../LiveStatus";

export type OpenTablesSheetProps = {
  isOpen: boolean;
  onClose: () => void;
};

/** Responsive access to the shared live-service view from the Overview bar. */
export const OpenTablesSheet = defineComponent<OpenTablesSheetProps>({
  name: "OpenTablesSheet",
  props: ["isOpen", "onClose"],
  setup(props) {
    const { t } = useLocalization();

    return () => {
      if (!props.isOpen) return null;

      return (
        <RightSheet
          isOpen={true}
          mobileVariant={"full-screen"}
          title={t("reports.live.title")}
          onClose={() => props.onClose()}
          width="640px"
          testId="open-tables-sheet"
        >
          <div class="min-h-0 flex-1 overflow-y-auto">
            <LiveStatusPage />
          </div>
        </RightSheet>
      );
    };
  },
});
